var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM6.532 12.11L3.01 8.586l1.174-1.174L6.532 9.76l5.284-5.283 1.174 1.174-6.458 6.457z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP1);
export default __webpack_public_path__ + "static/media/p-1.3934e6d531fc74f9a1774f101b07872e.svg";
export { ForwardRef as ReactComponent };